import { useEffect, useState } from "react";
import "../components/login/Login.css";

import StatusDisplay from "../components/feedback/Status";
import LoginForm from "../components/login/LoginForm";
import { Status } from "../enums/status";
import useRequests from "../hooks/http";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function Login() {
  const { post } = useRequests();
  const navigate = useNavigate();
  const [params, setSearchParams] = useSearchParams();
  const [appStatus, setStatus] = useState(Status.PENDING);
  const [message, setMessage] = useState("");

  const login = async (e: LoginProps) => {
    setStatus(Status.LOADING);
    const { data, status } = await post("/users/authenticate", e);
    setMessage(data.message);
    if (status === 401) {
      setStatus(Status.ERROR);
    } else if (status === 200) {
      setStatus(Status.SUCCESS);
      setMessage(data.message);
      return navigate("/app");
    }
  };

  function isOAuthContext() {
    return params.get("client_id") && params.get("redirect_uri");
  }

  function intitiateFormData(clientId: string, redirectUri: string): URLSearchParams {
    const form = new URLSearchParams();
    form.append("client_id", clientId);
    form.append("redirect_uri", redirectUri);
    form.append("grant_type", "authorization_code");
    return form;
  }

  function initiateOauthAuthCodeFlow(code: string, redirectUri: string, state: string) {
    const form = new URLSearchParams();
    form.append("redirect_uri", redirectUri);
    form.append("code", code);
    form.append("state", state);
    form.append("grant_type", "authorization_code");
    return form;
  }

  async function directConsoleLogin(e: any) {
    let path = "/platform/oauth/google";
    await post(path, null, { code: e.code });
    return navigate("/app");
  }

  const google = async (e: any) => {
    if (!isOAuthContext()) {
      return directConsoleLogin(e);
    }
    const clientId = params.get("client_id") as string;
    let redirect = params.get("redirect_uri") as string;

    const {
      data: { state },
    } = await post("/initiate", intitiateFormData(clientId, redirect), undefined);
    setStatus(Status.LOADING);

    let path = "/oauth/google";

    const { data, status } = await post(path, initiateOauthAuthCodeFlow(e.code, redirect, state));
    const token = data.access_token;

    if (!status) {
      setMessage(
        "Shoot, having some issues with the authorization server. Seems we have some gremlins chewing cables here, chief!"
      );
      return setStatus(Status.ERROR);
    }

    if (status === 401) {
      setMessage(data.detail.message);
      return setStatus(Status.ERROR);
    }

    setStatus(Status.SUCCESS);
    setMessage(data.message || "Successfully authorized! Proceeding with redirect or login flow now.");

    redirect = `${redirect}?code=${token}`;
    window.location.href = redirect as string;
    return;
  };

  return (
    <LoginForm callback={login} google={google}>
      <StatusDisplay status={appStatus} message={message} />
    </LoginForm>
  );
}
